
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries/food-technology/products/nutritional-analysis-software",
      function () {
        return require("private-next-pages/industries/food-technology/products/nutritional-analysis-software.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industries/food-technology/products/nutritional-analysis-software"])
      });
    }
  